import ReactSelect from "react-select";
import styled from "styled-components";

const Select = styled(ReactSelect)``;

/* eslint-disable-next-line react/jsx-props-no-spreading */
const SelectComp = (props) => <Select {...props} />;

export default SelectComp;
